import { getCognitoToken, getWebpackEnvVar } from '@trqk/utils';

export const getToken = async (): Promise<Maybe<string>> => {
    const clientId = getWebpackEnvVar('web', 'AWS_APP_CLIENT_ID');
    const userPoolId = getWebpackEnvVar('web', 'AWS_USER_POOL_ID');
    const { token } = await getCognitoToken({
        clientId,
        userPoolId,
    });

    return token;
};
